// Motion utilities using Framer Motion v4 for React 17 compatibility
// Framer Motion v4 provides excellent animations and is fully compatible with React 17

import { motion as motionLib, AnimatePresence as AnimatePresenceLib } from 'framer-motion';

// Re-export with consistent naming
export const motion = motionLib;
export const AnimatePresence = AnimatePresenceLib;

// Export commonly used variants optimized for Motion.dev
export const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
  transition: { duration: 0.3, ease: [0.4, 0, 0.2, 1] } // Custom cubic-bezier for smooth motion
};

export const fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.2, ease: 'easeOut' }
};

export const scaleIn = {
  initial: { scale: 0.9, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  exit: { scale: 0.9, opacity: 0 },
  transition: { duration: 0.3, ease: [0.4, 0, 0.2, 1] }
};

export const slideIn = {
  initial: { x: -20, opacity: 0 },
  animate: { x: 0, opacity: 1 },
  exit: { x: 20, opacity: 0 },
  transition: { duration: 0.3, ease: [0.4, 0, 0.2, 1] }
};

// Motion.dev specific variants for better UX
export const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.1
    }
  }
};

export const staggerItem = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.3, ease: [0.4, 0, 0.2, 1] }
};

// Button animations with Motion.dev's gesture support
export const buttonHover = {
  scale: 1.02,
  transition: { duration: 0.2, ease: 'easeOut' }
};

export const buttonTap = {
  scale: 0.98,
  transition: { duration: 0.1, ease: 'easeOut' }
};

// Form input animations
export const inputFocus = {
  scale: 1.01,
  transition: { duration: 0.2, ease: 'easeOut' }
};

// Modal animations
export const modalBackdrop = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.3, ease: 'easeOut' }
};

export const modalContent = {
  initial: { opacity: 0, scale: 0.9, y: 20 },
  animate: { opacity: 1, scale: 1, y: 0 },
  exit: { opacity: 0, scale: 0.9, y: 20 },
  transition: { duration: 0.3, ease: [0.4, 0, 0.2, 1] }
};
